import { render, staticRenderFns } from "./SubAgentTab.vue?vue&type=template&id=0b114fb2&scoped=true"
import script from "./SubAgentTab.vue?vue&type=script&lang=js"
export * from "./SubAgentTab.vue?vue&type=script&lang=js"
import style0 from "./SubAgentTab.vue?vue&type=style&index=0&id=0b114fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b114fb2",
  null
  
)

export default component.exports